import React, { useState } from 'react';
import { useDataProvider, useNotify } from 'react-admin';
import Button from '@material-ui/core/Button';
import ConfirmationModal from '../../../../components/ConfirmationModal';

const DeleteButton = ({record, onSuccess}) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false)
  const dataProvider = useDataProvider();
  const notify = useNotify();

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const handleConfirm = async() => {
    setLoading(true);
    try {
      await dataProvider.delete('teammates', { id: record.id })
      notify(`Teammate has been successfully deleted.`, 'info');
      closeModal();
      onSuccess();
    }catch(error){
      notify(error.message, 'warning');
    }finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Button id="delete-teammate-button" variant="text" onClick={openModal}>Delete</Button>
      <ConfirmationModal
        open={showModal}
        title={`Are you sure you want to remove ${record.email} from your account?`}
        message="When you remove a teammate they will lose access to your company account."
        okText="YES"
        cancelText="CANCEL"
        loading={loading}
        onOk={handleConfirm}
        onCancel={closeModal}
      />
    </>
  )
}

DeleteButton.defaultProps = {
  onSuccess: () => {}
}

export default DeleteButton;